export default __webpack_public_path__ + "static/media/12.d6f3c4f7.png";